var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrolled),expression:"scrolled"},{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: '#header',
    duration: 500,
    lazy: false,
    easing: 'linear',
    offset: -200,
    force: true,
    cancelable: true,
       onStart: _vm.onStart,
    onDone: _vm.onDone,
    onCancel: _vm.onCancel,
    x: false,
    y: true
}),expression:"{\n    el: '#header',\n    duration: 500,\n    lazy: false,\n    easing: 'linear',\n    offset: -200,\n    force: true,\n    cancelable: true,\n       onStart: onStart,\n    onDone: onDone,\n    onCancel: onCancel,\n    x: false,\n    y: true\n}"}],staticClass:"btn-to-top",attrs:{"disabled":_vm.scrolling}},[_c('i',{staticClass:"btn-to-top__icon"},[_c('svg',{attrs:{"id":"icon-to-top","width":"29","height":"30","viewBox":"0 0 29 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.283 0.419958L14.2821 0.420784L14.2779 0.416683L0.0171153 14.27L1.0458 15.2693L13.5282 3.14357L13.5282 29.8526L15.0294 29.8526L15.0294 3.14366L27.5117 15.2693L28.5403 14.27L14.283 0.419958Z","fill":"white"}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }